import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyUsageChart", "weeklyUsageChart"]
  static values = { url: String }

  initialize() {
    fetch(this.urlValue)
      .then((response) => response.json())
      .then((data) => {
        this.usageChart(data.weekly_usage, this.weeklyUsageChartTarget)
        this.usageChart(data.monthly_usage, this.monthlyUsageChartTarget)
      })
  }

  usageChart(data, target) {
    const labelsArray = []
    const seriesArray = []
    const options = {
      width: "500px",
      height: "250px",
      axisX: {
        labelInterpolationFnc(value) {
          return value.substring(5)
        },
      },
    }

    data.forEach((element) => {
      labelsArray.push(element[0])
      seriesArray.push(element[1])
    })

    const weekData = {
      labels: labelsArray,
      series: [{ data: seriesArray }],
    }

    if ($(target).length > 0) {
      new Chartist.Bar(target, weekData, options)
    }
  }
}
